
 const keys = {

    server: "https://royalmarketing.rib.lk/api"


}

export default keys
